module.exports = __webpack_public_path__ + "static/img/areaA-4.3c81b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-4.png
// module id = 951
// module chunks = 1